<section class="trend_search">
  <div class="container">
      <div class="row">
          <div class="col-md-12">
            <div class="search-form-position">
              <div class="search-form">
                  <form>
                    <div class="search-border">
                      <div class="search-input">
                          <img src="../../../../assets/img/Icon/search.svg" />
                          <input
                            id="search-input"
                            type="text"
                            [placeholder]="'search.title' | translate"
                            [(ngModel)]="searchQuery"
                            (ngModelChange)="onSearchInput($event)"
                            (blur)="onInputBlur()"
                            name="searchQuery"
                            autocomplete="off"
                            />
                      </div>
                    </div>
                      <div class="close-search">
                          <a (click)="closeModal(true)">
                              <img src="../../../assets/img/Icon/close.svg" />
                          </a>
                      </div>
                  </form>
                </div>
              </div>
            </div>
      </div>
  </div>
              <div class="search-scroll">
                <div class="container">
                  <div *ngIf="searchQuery.length <= 1" class="trending-search-block">
                      <div class="recent-search"
                        *ngIf="recentSearches.length > 0">
                          <label><img src="../../../assets/img/Icon/recent.svg" />{{'search.recent' | translate}}</label>
                          <ul>
                              <li *ngFor="let item of recentSearches | slice:0:6"
                                (click)="searchWithField(item)">
                                <a>
                                  <span *ngIf="item.length <= 17">{{ item }}</span>
                                  <span *ngIf="item?.length > 17">{{ item | slice:0:15}}...</span>
                                  <img src="../../../assets/img/Icon/close.svg"
                                    (click)="openDeleteRecentItemModal(deleteRecentItemModal, $event, item)"/>
                                </a>
                              </li>
                          </ul>

                          <div class="tooltip_view">
                              <a class="delete-recent-search"
                                (click)="openDeleteAllRecentModal(deleteAllRecentModal, $event)"></a>
                              <span class="tooltip_text">
                                {{ 'search.clearHistory' | translate }}
                              </span>
                          </div>
                      </div>

                      <ng-container
                        *ngIf="trendingResult.length > 0">
                        <div class="trending-search-list">
                            <label>{{'search.trending' | translate}}</label>
                        </div>

                        <div class="search-assets">
                            <ul>
                                <li (click)="closeModal()" class="item assets_hover new_asset_hover_type" *ngFor="let item of trendingResult; let i = index">
                                    <div class="new_asset" (click)="goto(item, loginPopup, i)">
                                        <div class="new_asset_img">
                                          <image-manipulation [assetName]="item.name"
                                          [img]="commonService.isLandscapePriority() ? item.image : item.image_portrait"
                                          [params]="commonService.isLandscapePriority() ? { 'width': 512, 'height': 288 } : commonService.getThumbnailParams({ 'width': 220, 'height': 330 })"
                                          [notFound]="commonService.isLandscapePriority() ? 'landscape' : 'portrait'"></image-manipulation>

                                            <a class="_premium"
                                              *ngIf="strToLower(item.content_availability) == 'paid' && item.hide_tag == '0' ">
                                              <img class="crown" [src]="paidIcon">
                                            </a>

                                            <a class="_free_tag"
                                                *ngIf="strToLower(item.content_availability) == 'free' && item.hide_tag == '0' ">
                                                <img class="crown" [src]="freeIcon">
                                            </a>

                                            <a class="_free_tag"
                                                *ngIf="strToLower(item.content_availability) == 'no tag' && item.hide_tag == '0' ">
                                            </a>

                                        </div>
                                        
                                        <app-item-hover
                                          [item]="item"
                                          [page_view]="'Screen_Home'"
                                          (addToWatchlist)="addToWatchlistArray($event)"
                                          (removeFromWatchlist)="removeFromWatchlistArray($event)">
                                        </app-item-hover>
                                    </div>
                                </li>
                            </ul>
                        </div>
                      </ng-container>
                  </div>
                  
                  <div *ngIf="searchQuery.length > 1" class="enter-text-search">
                      <div class="text-keyword-search">
                          <!-- <div class="recent-search">
                              <ul>
                                  <li>
                                      <img src="../../../assets/img/Icon/search.svg" />
                                      <span>Defines the value of the credentials flag for CORS requests. 1</span>
                                  </li>
                              </ul>
                          </div> -->
                          <div class="recent-search">
                              <div class="ais-Hits">
                                <ul *ngIf="searchSuggestions?.length > 1">
                                  <li *ngFor="let hit of searchSuggestions | slice:0:6"
                                    (click)="searchWithField(hit)">
                                      <a>
                                          <img src="../../../assets/img/Icon/search.svg" />
                                          <span>{{hit}}</span>
                                      </a>
                                  </li>
                                </ul>
                              </div>
                          </div>
                          <label
                          *ngIf="allSearchResults.length > 0">{{ 'search.resultsFor' | translate:{query: searchQuery} }}</label>
                      </div>

                      <div class="search-nav" *ngIf="isSearchResultFetched">

                        <!-- remove display none to show search nav -->
                          <ul style="display: none;" class="nav nav-tabs" id="search_tab_1" role="tablist">
                            <li class="nav-item">
                              <a *ngIf="allSearchResults.length > 0"
                                href="javascript:;"
                                class="nav-link"
                                [ngClass]="{'show active': activeTab === 'all-tab'}"
                                (click)="updateActiveTab($event)"
                                data-toggle="tab" data-target="#all-tab" role="tab" aria-selected="true">
                                Show All
                              </a>
                            </li>
                            <li class="nav-item" *ngFor="let item of filteredSearchResults">
                              <a href="javascript:;"
                                class="nav-link"
                                [ngClass]="{'show active': activeTab === item.type + '-tab'}"
                                (click)="updateActiveTab($event)"
                                data-toggle="tab"
                                [attr.data-target]="'#' + item.type + '-tab'" role="tab" aria-selected="false">
                                {{ item.name }}
                              </a>
                            </li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane fade"
                              [ngClass]="{'show active': activeTab === 'all-tab'}"
                              id="all-tab"
                              role="tabpanel"
                              aria-labelledby="all-tab">
                              <div class="other_assests">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="search-assets">
                                      <ul *ngIf="allSearchResults.length > 0">
                                      
                                        <li  class="item new_asset_hover_type assets_hover search-assets-gap"
                                        [ngClass]="{'assets_hover': assets_hover }"
                                          *ngFor="let item of allSearchResults; let i = index"
                                          (mouseenter)="assetHover(item?.source?.data)"
                                           (mouseleave)="item_hover_leave(item, i)"
                                           [id]="'item_expend'+item?.source?.data?.code+item?.source?.data?.category_slug" 
                                            [hidden]="item?.source?.data?.code == 'testcode'">
                                          <div class="new_asset" (click)="goto(item.source.data, loginPopup, i)">
                                            <div class="new_asset_img">
                                              <image-manipulation [assetName]="item.source.data.name"
                                                [img]="commonService.isLandscapePriority() ? item.source.data.image : item.source.data.image_portrait"
                                                [params]="commonService.isLandscapePriority() ? { 'width': 512, 'height': 288 } : commonService.getThumbnailParams({ 'width': 220, 'height': 330 })"
                                                [notFound]="commonService.isLandscapePriority() ? 'landscape' : 'portrait'"></image-manipulation>

                                                <a class="_premium"
                                                  *ngIf="strToLower(item.source.data.content_availability) == 'paid' && item.source.data.hide_tag == '0' ">
                                                  <img class="crown" [src]="paidIcon">
                                                </a>

                                                <a class="_free_tag"
                                                    *ngIf="strToLower(item.source.data.content_availability) == 'free' && item.source.data.hide_tag == '0' ">
                                                    <img class="crown" [src]="freeIcon">
                                                </a>

                                                <a class="_free_tag"
                                                    *ngIf="strToLower(item.source.data.content_availability) == 'no tag' && item.source.data.hide_tag == '0' ">
                                                </a>
                                            </div>
                                            <app-item-hover
                                              [item]="item.source.data"
                                              [page_view]="'Screen_Home'"
                                              [hoveredAssetCode]="hoveredAssetCode"
                                              (addToWatchlist)="addToWatchlistArray($event)"
                                              (removeFromWatchlist)="removeFromWatchlistArray($event)"></app-item-hover>
                                          </div>
                                        </li>
                                      </ul>
                                      <div *ngIf="allSearchResults.length == 0">
                                      <div class="_not_find">
                                        <div class="search-not-found" >
                                            <img src="../../../assets/img/Icon/search-result.svg" />
                                            <p>{{'search.noResults' | translate }}</p>
                                            <span>'{{searchQuery}}'</span>
                                        </div>
                                      </div>

                                      <div class="trending-search-block"
                                        *ngIf="trendingResult.length > 0">
                                        
                
                                        <div class="trending-search-list text-left">
                                            <label>{{ 'search.trending' | translate }}</label>
                                        </div>
                
                                        <div class="search-assets">
                                          <ul>
                                              <li (click)="closeModal()" class="item assets_hover new_asset_hover_type" *ngFor="let item of trendingResult; let i = index">
                                                  <div class="new_asset" (click)="goto(item, loginPopup, i)">
                                                      <div class="new_asset_img">
                                                        <image-manipulation [assetName]="item.name"
                                                        [img]="commonService.isLandscapePriority() ? item.image : item.image_portrait"
                                                        [params]="commonService.isLandscapePriority() ? { 'width': 512, 'height': 288 } : commonService.getThumbnailParams({ 'width': 220, 'height': 330 })"
                                                        [notFound]="commonService.isLandscapePriority() ? 'landscape' : 'portrait'"></image-manipulation>
                                                        
                                                        <a class="_premium"
                                                          *ngIf="strToLower(item.content_availability) == 'paid' && item.hide_tag == '0' ">
                                                          <img class="crown" [src]="paidIcon">
                                                        </a>

                                                        <a class="_free_tag"
                                                            *ngIf="strToLower(item.content_availability) == 'free' && item.hide_tag == '0' ">
                                                            <img class="crown" [src]="freeIcon">
                                                        </a>

                                                        <a class="_free_tag"
                                                            *ngIf="strToLower(item.content_availability) == 'no tag' && item.hide_tag == '0' ">
                                                        </a>

                                                      </div>
                                                      <app-item-hover
                                                        [item]="item"
                                                        [page_view]="'Screen_Home'"
                                                        (addToWatchlist)="addToWatchlistArray($event)"
                                                        (removeFromWatchlist)="removeFromWatchlistArray($event)"></app-item-hover>
                                                  </div>
                                              </li>
                                          </ul>
                                      </div>
                                    </div>
                                  </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngFor="let item of filteredSearchResults"
                              class="tab-pane fade"
                              [ngClass]="{'show active': activeTab === item.type + '-tab'}"
                              id="{{item.type}}-tab"
                              role="tabpanel"
                              [attr.aria-labelledby]="item.type+ '-tab'">
                              <div class="other_assests">
                                <div class="container-fluid">
                                  <div class="row">
                                    <div class="col-sm-12">
                                      <div class="search-assets">
                                        <ul>
                                          <li class="item assets_hover new_asset_hover_type search-assets-gap"
                                            *ngFor="let hit of item.results"
                                            (mouseenter)="assetHover(hit.document)">
                                            <div class="new_asset">
                                              <div class="new_asset_img">
                                                <image-manipulation [assetName]="hit.document.name"
                                                  [img]="commonService.isLandscapePriority() ? hit.document.image : hit.document.image_portrait"
                                                  [params]="commonService.isLandscapePriority() ? { 'width': 512, 'height': 288 } : commonService.getThumbnailParams({ 'width': 220, 'height': 330 })"
                                                  [notFound]="commonService.isLandscapePriority() ? 'landscape' : 'portrait'"></image-manipulation>

                                                  <a class="_premium"
                                                    *ngIf="strToLower(item.document.content_availability) == 'paid' && item.document.hide_tag == '0' ">
                                                    <img class="crown" [src]="paidIcon">
                                                  </a>

                                                  <a class="_free_tag"
                                                      *ngIf="strToLower(item.document.content_availability) == 'free' && item.document.hide_tag == '0' ">
                                                      <img class="crown" [src]="freeIcon">
                                                  </a>

                                                  <a class="_free_tag"
                                                      *ngIf="strToLower(item.document.content_availability) == 'no tag' && item.document.hide_tag == '0' ">
                                                  </a>

                                              </div>
                                              <app-item-hover
                                                [item]="hit.document"
                                                [page_view]="'Screen_Home'"
                                                (addToWatchlist)="addToWatchlistArray($event)"
                                                (removeFromWatchlist)="removeFromWatchlistArray($event)"></app-item-hover>
                                            </div>
                                          </li>
                                          </ul>
                                        <div class="_not_find">
                                          <h4 class="no-result" *ngIf="item.results.length == 0">{{'search.noResults' | translate }}
                                            <span> <b>"{{searchQuery}}" </b></span>
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                        
                  </div>
                  </div>
              </div>
          
</section>
<ng-template #deleteAllRecentModal>


  
    <!-- <button type="button" class="close popup_close" data-dismiss="modal">&times;</button> -->
    <p class="text-white" style="font-weight: 200;width: calc(100% - 100px);">
      {{ 'areYouSure' | translate }}
    </p>

          <div class="text-right mt-2">
              <button class="btn btn-default popup_btn btn_hover  mr-3"
                (click)="closeDeleteAllRecentModal()">
                  <span>{{ 'cancel' | translate }}</span>
              </button>
              <button class="btn btn-default popup_btn btn_hover"
                (click)="clearAllRecentSearches()"
                data-dismiss="modal">
                  <span>
                    {{ 'search.clearHistory' | translate }}
                  </span>
              </button>
          </div>

</ng-template>
<ng-template #deleteRecentItemModal>
<!-- <div class="modal auth popup_background" id="deleteRecentItemModal"> -->



  
    <!-- <button type="button" class="close popup_close" data-dismiss="modal">&times;</button> -->
    <p class="text-white" style="font-weight: 200;width: calc(100% - 100px);">
      {{ 'search.clearHistory' | translate:{item: currentDeleteItem} }}
    </p>

          <div class="text-right mt-2">
              <button class="btn btn-default popup_btn btn_hover  mr-3"
                (click)="closeDeleteRecentItemModal()">
                  <span>{{ 'cancel' | translate }}</span>
              </button>
              <button class="btn btn-default popup_btn btn_hover"
                (click)="removeFromRecentSearches($event, currentDeleteItem)">
                  <span>
                      {{ 'search.clearHistory' | translate }}
                  </span>
              </button>
          </div>

</ng-template>
<ng-template #loginPopup>
<app-login-register (onModalClose)="closeLoginModal($event)"></app-login-register>
</ng-template>